module.exports = __webpack_public_path__ + "img/9c574c7.jpg";